const DeviceTypeLabel = Object.freeze({
  ios: 'DeviceType_Ios',
  android: 'DeviceType_Android',
  web: 'DeviceType_Web'
})

export { DeviceTypeLabel }



// WEBPACK FOOTER //
// ./src/modules/devices/enum/DeviceTypeEnum.js